import React from 'react';

const PreviewMassage = ({title, setTitle, massage, setMassage, header, setHeader}) => {
    return (
        <div className='preview_verification_wrap'
        style={{maxHeight:'353px'}}>
        <div className='preview_verification_header'>
            <img className='preview_verification_header_img' src="/img/BotAva.svg" alt="" />
            <h4>Themis</h4>
            <div className='preview_verification_header_lable'>
                <img src="/img/check_white.svg" alt="" />
                <p>BOT</p>
            </div>
            <p className='preview_verification_header_date'>Today at 15:36</p>
        </div>
        <div className='preview_verification_content'>
            <div className='preview_verification_captcha preview_verification_custom-maggage '>
                <h3>{header}</h3>
                <h4>{title}</h4>
                <h5>{massage}</h5>
                <img className='preview_verification_captcha_plug'  src="/img/captchaPlug.png" alt="" />
                <div className='preview_verification_captcha_content'>
                    <img src="/img/customMassageImg.png" alt="" />
                </div>
                <div className='preview_verification_captcha_content preview_verification_custom-maggage_admin'>
                    <img className='preview_verification_keyboadr_item_check' src="/img/botMini.svg" alt="" />
                    <h5>This message was sent by server administrator.</h5>
                </div>
            </div>
            <div className='preview_verification_keyboadr_wrap'>
            <button 
                className='preview_verification_keyboadr_item'
                >
                    Continue
                </button>
            </div>

        </div>
    </div>
    );
};

export default PreviewMassage;